import { render, staticRenderFns } from "./EntregaOrder.vue?vue&type=template&id=2d9595fe&"
import script from "./EntregaOrder.vue?vue&type=script&lang=js&"
export * from "./EntregaOrder.vue?vue&type=script&lang=js&"
import style0 from "./EntregaOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports